import { render } from "./login.vue?vue&type=template&id=5dc1dc71&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=5dc1dc71&scoped=true&lang=css"
import "./login.vue?vue&type=style&index=1&id=5dc1dc71&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc1dc71"]])

export default __exports__